import { TOKENS_VARIABLE } from '@/assets/util/constants/constants'

export default {
  getRespectiveErrorMsg: function(res) {
    let code = res.error[0].code
    let domain = res.error[0].input.domain
    let datamap = {}
    code = Number(code)
    switch (code) {
      case 505:
      case 702:
      case 403:
        datamap = {
          butText: 'Add domain to find email'
        }
        break
      case 501:
        datamap = {
          butText: 'Try for a valid email domain',
          msg: "Company's email server is different from its domain"
        }
        break
      case 703:
      case 503:
      case 502:
        datamap = {
          butText: 'Try for a different domain',
          msg: `Unable to find email ${
            domain ? 'for the domain ' + domain : ''
          }`
        }
        break
      case 701:
        datamap = {
          butText: 'Add company to find email'
        }
        break
      case 504:
      case 500:
        datamap = {
          msg:
            'We are still trying to find the email address. Please try after some time.'
        }
    }
    return datamap
  },
  checkIfFieldsParsed: function(profileData) {
    const hasValue = (val) => {
      return (
        val !== undefined && val !== null && val !== '' && val.trim() !== ''
      )
    }

    const hasFullName = hasValue(profileData.fullName || '')
    const hasTitle = hasValue(profileData.title || '')
    const hasCompanyName =
      profileData.company && hasValue(profileData.company.name || '')
    const hasCompanyUrl = hasValue(profileData.linkedinCompanyPageUrl || '')
    const hasIsActivelyWorking =
      profileData.isActivelyWorking !== undefined &&
      profileData.isActivelyWorking !== null
    const hasIsVerifiedDomain =
      profileData.isValidDomain !== undefined &&
      profileData.isValidDomain !== null

    // Return true ONLY if ALL required fields are present
    return (
      hasCompanyName &&
      hasFullName &&
      hasTitle &&
      hasCompanyUrl &&
      hasIsActivelyWorking &&
      hasIsVerifiedDomain
    )
  },
  getFilteredData: function(profileData, addFirstData = true) {
    let filteredData = {}
    filteredData.experience = []
    filteredData.fullName = profileData.fullName
    const firstData = {
      companyUrl: profileData.linkedinCompanyPageUrl,
      isVerifiedDomain: profileData.isValidDomain,
      isActivelyWorking: profileData.isActivelyWorking,
      title: profileData.title,
      companyName:
        profileData.company === undefined ? '' : profileData.company.name,
      domain:
        profileData.company === undefined ? '' : profileData.company.domain,
      address:
        profileData.company === undefined ? '' : profileData.company.address
    }
    if (profileData.experience && profileData.experience.length > 0) {
      filteredData.experience = profileData.experience
      if (addFirstData) filteredData.experience.unshift(firstData)
    } else {
      filteredData.experience.push(firstData)
    }
    const { linkedinLanguage = null } = profileData
    if (linkedinLanguage != null) {
      const metaData = {
        linkedinLanguage
      }
      filteredData.metaData = metaData
    }
    filteredData.address = profileData.address
    filteredData.connections = profileData.connections
    filteredData.linkedInProfileUrl = profileData.linkedinId
    
    filteredData.isParsed = this.checkIfFieldsParsed(profileData)
    
    return filteredData
  },
  showNotificationMsg: function(msg, time) {
    time = time ? time : 2000
    const div = document.createElement('div')
    const span = document.createElement('span')
    div.className = 'notification-banner'
    span.className = 'banner-txt'
    span.innerText = msg

    const iconWrap = document.createElement('div')
    iconWrap.classList.add('icon-wrap')
    iconWrap.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z" stroke="#FF4788" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.7295 21C13.5537 21.3031 13.3014 21.5547 12.9978 21.7295C12.6941 21.9044 12.3499 21.9965 11.9995 21.9965C11.6492 21.9965 11.3049 21.9044 11.0013 21.7295C10.6977 21.5547 10.4453 21.3031 10.2695 21" stroke="#FF4788" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    `
    div.appendChild(iconWrap)
    div.appendChild(span)
    document.body.appendChild(div)
    setTimeout(function() {
      div.className = 'notification-banner close'
      setTimeout(function() {
        div.remove()
      }, 300)
    }, time)
  },
  mixpanelIdentify: function(email) {
    window.mixpanel.identify(email)
  },
  track: function(event, data, state) {
    let property = {}
    if (data) {
      property = data
    }
    property.currentWindowUrl = localStorage.getItem('currentWindowUrl')
    window.mixpanel.cookie && this.passMxIdToBg()
    property.distinct_id = this.getMXIdFromUrl()
    this.getMXIdFromUrl() &&
      window.mixpanel.register({ distinct_id: this.getMXIdFromUrl() })
    this.checkAndSetMixpanelAlias()
    if (state && state.header && state.header.email) {
      property.lbCreditsPlan = state.header.lbCreditsPlan
      if (state.header.lbCreditsPlan) {
        property.creditsRemaining = state.header.credits
      } else {
        property.viewsRemaining = state.header.views
        property.downloadsRemaining = state.header.downloads
      }

      property.userEmail = state.header.email
      property.distinct_id = state.header.email //overide with email
      property.dockModeType = state.dockModeType
      property.isPaidUser = state.header.isPaidUser
      property.source = state.header.source
      property.registeredDate = state.header.registeredDate
        ? new Date(state.header.registeredDate).toString()
        : ''

      window.mixpanel.track(event, property)
    } else {
      const that = this
      setTimeout(function() {
        if (state && state.isDockSettingsAvailable) {
          property.dockModeType = state.dockModeType
        }
        window.mixpanel.cookie
          ? (window.mixpanel.cookie.props.distinct_id = that.getMXIdFromUrl())
          : ''
        if (state && state.header.email) {
          window.mixpanel.cookie.props.distinct_id = state.header.email //overide with email
          property.distinct_id = state.header.email //overide with email
          property.userEmail = state.header.email

          property.lbCreditsPlan = state.header.lbCreditsPlan
          if (state.header.lbCreditsPlan) {
            property.creditsRemaining = state.header.credits
          } else {
            property.viewsRemaining = state.header.views
            property.downloadsRemaining = state.header.downloads
          }
        }
        window.mixpanel.track(event, property)
      }, 3000)
    }
  },
  mixpanelUpdateProfileProperty: function(props) {
    window.mixpanel.people.set(props)
  },
  generateUUID: function() {
    const hexDigits = '0123456789ABCDEF'
    let macAddress = ''
    for (var i = 0; i < 10; i++) {
      macAddress += hexDigits.charAt(Math.round(Math.random() * 15))
      macAddress += hexDigits.charAt(Math.round(Math.random() * 15))
    }
    const date = new Date()
    const milliSeconds = date.getTime()
    return macAddress + milliSeconds
  },
  passMsgToContentScript(msg) {
    window.postMessage(msg, window.location.href)
  },
  clickToCopy: function(cId, mail, name, event, dataMap, txtDisplay, state) {
    document.getElementById(cId + name).value = mail
    document.getElementById(cId + name).select()
    document.execCommand('copy')
    this.showNotificationMsg(txtDisplay, 2000)
    if (event != null) this.track(event, dataMap, state)
  },
  checkAndSetMixpanelAlias() {
    const mDistinctId = this.getMXIdFromUrl()
    if (mDistinctId) {
      window.mixpanel.alias(mDistinctId)
    }
  },
  getMXIdFromUrl() {
    const url = window.location.href
    if (url && url.indexOf('mxId=') != -1) {
      const mDistinctId = url.split('mxId=')[1]
      return mDistinctId
    }
  },
  passMxIdToBg() {
    const data = window.mixpanel.cookie.props.distinct_id
    window.postMessage({ data, type: 'PASS_MX_ID_BG' }, '*')
  },
  checkEmailDomain(email, domain) {
    const emailAddress = email.toLowerCase()
    if (emailAddress && domain) {
      const newDomain = emailAddress.split('@').pop()
      if (newDomain && newDomain.indexOf(domain) >= 0) {
        return false
      }
    }
    return true
  },
  findTokenInContent(content) {
    const tokenList = []
    if (content && content.length) {
      if (TOKENS_VARIABLE && TOKENS_VARIABLE.length) {
        TOKENS_VARIABLE.map(item => {
          if (item && item.value && content.includes(item.value)) {
            tokenList.push(item.key)
          }
        })
      }
    }
    return tokenList
  },
  getUniqueArrayList(dataArr) {
    const resultArr = dataArr.filter((data, index) => {
      return dataArr.indexOf(data) === index
    })
    return resultArr
  },
  getCombineTokenList(subList, contList) {
    let newArrList = []
    if (subList.length > 0 && contList.length > 0) {
      newArrList = [...subList, ...contList]
      return this.getUniqueArrayList(newArrList)
    } else if (subList.length > 0 && !contList.length) {
      return subList
    } else if (!subList.length && contList.length > 0) {
      return contList
    }
    return newArrList
  },
  checkSubjectStageHasToken(seqObj) {
    let tokenList = []
    let contTokenList = false
    let subTokenList = false
    const { stages = {} } = seqObj
    const stagesLen = Object.keys(stages).length
    for (let i = 1; i <= stagesLen; i++) {
      if (
        stages[i].type.toLowerCase() === 'manualemail' ||
        stages[i].type.toLowerCase() === 'email'
      ) {
        subTokenList = this.findTokenInContent(stages[i].subject)
        contTokenList = this.findTokenInContent(stages[i].content)
        if (subTokenList && subTokenList.length > 0) {
          subTokenList.map(item => {
            tokenList.push(item)
          })
        }
        if (contTokenList && contTokenList.length > 0) {
          contTokenList.map(item => {
            tokenList.push(item)
          })
        }
      }
    }
    return this.getUniqueArrayList(tokenList)
  },
  getObjPropertyKey(key) {
    if (key === 'companyName') {
      return 'company'
    } else if (key === 'phoneNumber') {
      return 'phone'
    } else {
      return key
    }
  },
  getContactEmptyToken(token, contact) {
    const newTokenArrList = []
    let contactObjKeyList = Object.keys(contact)
    token.map(key => {
      let fieldKey = this.getObjPropertyKey(key)
      let contactValue = contact[fieldKey]
      if (
        (contactObjKeyList.indexOf(fieldKey) !== -1 && !contactValue) ||
        contactObjKeyList.indexOf(fieldKey) < 0
      ) {
        newTokenArrList.push(key)
      }
    })
    return newTokenArrList
  },
  sequenceHasStage(seqObj) {
    const { stages = {} } = seqObj
    return Object.keys(stages).length
  }
}
